import { NavLink } from "react-router-dom";

import { PiMoneyBold } from "react-icons/pi";

import {  MdDashboard, MdPayments } from "react-icons/md";
import { FaRupeeSign } from "react-icons/fa";
import {  FaUser } from "react-icons/fa6";
import { LiaGamepadSolid } from "react-icons/lia";

export const Menuitems = () => {
  const list = [
    {
      key: "1",
      icon: <MdDashboard/>,
      label: (
        <NavLink to={"/dashboard"}>
          <p>Dashboard</p>
        </NavLink>
      ),
    },
    {
      key: "6",
      icon: <FaUser />,
      label: (
        <NavLink to={"/user-list"}>
          <p>User List</p>
        </NavLink>
      ),
    },
    {
      key: "8.1",
      icon: <LiaGamepadSolid />,
      label: (
        <NavLink to={"/number-game/rooms"}>
          <p>Number Game</p>
        </NavLink>
      ),
    },
    {
      key: "3",
      icon: <MdPayments />,
      label: (
        <NavLink to={"/payment-setting"}>
          <p>Payment Setting</p>
        </NavLink>
      ),
    },
    {
      key: "4",
      icon: <FaRupeeSign />,
      label: (
        <NavLink to={"/fund-request"}>
          <p>Fund Request</p>
        </NavLink>
      ),
    },
    {
      key: "5",
      icon: <PiMoneyBold />,
      label: (
        <NavLink to={"/withdrawal-request"}>
          <p>Withdrawal Request</p>
        </NavLink>
      ),
    },
    {
      key: "7",
      icon: <PiMoneyBold />,
      label: (
        <NavLink to={"/comission"}>
          <p>Referal Comission</p>
        </NavLink>
      ),
    },
    {
      key: "12",
      icon: <PiMoneyBold />,
      label: (
        <NavLink to={"/comission-setting"}>
          <p>Comission Setting</p>
        </NavLink>
      ),
    },
  ];
  return list;
};
